import { KeyboardEvent } from 'react';

interface Props {
    placeholder?: string,
    onChange: (value: string) => void
}

const InputFilter = (props: Props) => {
    
    const { onChange } = props;

    const onKeyDown = (e?: KeyboardEvent<HTMLInputElement>) => {
        if (e?.key === 'Enter') {
            onChange(e.currentTarget.value);
        }
    }

    return (
        <input
            type="text"
            className='border w-full px-2 rounded'
            placeholder={props.placeholder}
            onKeyDown={onKeyDown}
        />
    )
}

export default InputFilter;